"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OverkillAbilityHandler = exports.OverkillActorAbilityFactory = exports.OverkillAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const AbilityDamage_1 = require("../../core/AbilityDamage");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const EffectType_1 = require("../../core/effects/EffectType");
const Registries_1 = require("../../core/state/Registries");
const core_1 = require("../../core/vfx/core");
const Random_1 = require("../../utils/Random");
class OverkillAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.Overkill;
        this.__typeName = "Overkill";
    }
}
exports.OverkillAbilityArgs = OverkillAbilityArgs;
let OverkillActorAbilityFactory = class OverkillActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("Overkill", "OneEnemies", 4);
    }
};
OverkillActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("Overkill")
], OverkillActorAbilityFactory);
exports.OverkillActorAbilityFactory = OverkillActorAbilityFactory;
let OverkillAbilityHandler = class OverkillAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const [selectedEnemy] = ability.args.target.actorIds;
        const shotsFired = (0, Random_1.random)(2, 5);
        for (let i = 0; i < shotsFired; i++) {
            if (container.isDeceased(selectedEnemy)) {
                break;
            }
            const abilityPower = Math.round((50 + 5 * i) * (container.hasEffectOfType(ability.invokerId, EffectType_1.EffectType.KillingMachine) ? 1 : 1.15));
            container.applyProjectileAttackWithDamage({
                sequence,
                idleAfter: i === (shotsFired - 1),
                abilityKey: ability.args.__typeName,
                attackType: "ranged",
                attackerId: ability.invokerId,
                targetId: selectedEnemy,
                projectileType: "GoldenArrow",
                projectilePath: "line",
                toApply: [
                    AbilityDamage_1.AbilityDamage.Power("Physical", abilityPower)
                ].filter(Boolean),
                onHit(sequence) {
                    if (container.isDeceased(selectedEnemy)) {
                        // We don't know if the target will be deceased when starting, so idleAfter can't handle this.
                        // If they die, be sure to reset the character back to the idle animation.
                        sequence.push(core_1.AnimateCharacterVfxStepArgs.Idle(ability.invokerId));
                    }
                }
            });
        }
    }
};
OverkillAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.Overkill)
], OverkillAbilityHandler);
exports.OverkillAbilityHandler = OverkillAbilityHandler;
